import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {QueryUserInformationModel, UserFilterModel, UserListModel} from '../../models/user/query-user.model';
import {Pageable} from '../../models/common/pageable.model';
import {Observable} from 'rxjs';

export interface RegisterUserRequest {
  email: string;
  userName: string;
  userGroup: number;
  birthday: string; // YYYY-MM-DD
  document: string;
  realName: string;
}

export interface EditUserRequest {
  userGroup: number;
  birthday: string; // YYYY-MM-DD
  document: string;
  realName: string;
  enabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly baseUrl = `${environment.backend.url}/api/user/v1`;

  constructor(private readonly http: HttpClient) {}

  public getUserByFilter(filter: UserFilterModel): Observable<Pageable<UserListModel>> {
    const paramsBase = new HttpParams()
      .append('page', filter.page)
      .append('pageSize', filter.pageSize);

    let params = paramsBase;
    if (filter.userName) {
      params = params.append('username', filter.userName);
    }

    if (filter.email) {
      params = params.append('email', filter.email);
    }

    if (filter.userGroup) {
      params = params.append('group', filter.userGroup);
    }

    return this.http.get<Pageable<UserListModel>>(`${this.baseUrl}/search`, {
      params: params
    });
  }

  public getUserById(userId: number): Observable<QueryUserInformationModel> {
    return this.http.get<QueryUserInformationModel>(`${this.baseUrl}/by-id/${userId}`);
  }

  public registerUser(payload: RegisterUserRequest): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/register`, payload);
  }

  public editUser(userId: number, payload: EditUserRequest): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/edit/${userId}`, payload);
  }
}
